<div class="titlebar">
  <div
    #pageHeading
    style="border-bottom: none"
    class="page-heading titlebar-heading"
    [ngClass]="hideLineBorderBottom()"
  >
    <div class="contents__column left-column">
      <div class="breadcrumb-container">
        <div *ngFor="let path of paths; index as index" class="breadcrumb-item">
          <i
            *ngIf="paths.length > 1 && index > 0"
            class="material-icons inline breadcrumb-arrow"
          >
            arrow_right
          </i>
          <h1
            class="page-title"
            [ngClass]="{
              active: activeClass(index, paths)
            }"
            (click)="navigateToRoute(path)"
            [title]="path.titleBreadcrumb"
          >
            {{ path.titleBreadcrumb }}
          </h1>
        </div>
      </div>
      <span
        *ngIf="integrationTooltipMessage"
        class="integration-tooltip"
        placement="right"
        [ngbTooltip]="integrationTooltipMessage"
        ><img
          src="/assets/img/integration-tooltip.svg"
          [alt]="integrationTooltipMessage"
      /></span>
    </div>

    <div class="contents__column right-column">
      <ng-content select="[select-custom]"></ng-content>
      <div class="page-button">
        <ng-content select="[button-adapted]"></ng-content>
        <lex-button
          *ngIf="!hideButtonTitlebar"
          [label]="labelButton"
          [isDisabled]="schoolHasExternalIntegrationId"
          (click)="onButtonClick()"
          icon="add"
          containerStyle="max-width: 320px; width: 100%; padding-right: 24px; padding-left: 24px;white-space: nowrap;"
          buttonClass="new-course-button"
        ></lex-button>
      </div>
    </div>
  </div>
</div>
